import React from "react"
import { IconButton, Icon, Stack, StackProps } from "@chakra-ui/react"
import { FiTwitter, FiInstagram, FiLinkedin, FiFacebook } from "react-icons/fi"

const SocialIcons: React.FC<
    { iconBoxSize?: "sm" | "md" | "lg" | "xl" } & StackProps
> = ({ iconBoxSize, ...props }) => {
    const iconSize = {
        sm: 4,
        md: 6,
        lg: 8,
        xl: 10,
    }[iconBoxSize || "lg"] as number

    return (
        <Stack
            w="min-content"
            justifyContent="center"
            alignItems="center"
            {...props}
        >
            <IconButton
                as="a"
                href={`https://twitter.com/chckvet`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Share on Twitter"
                icon={
                    <Icon
                        as={FiTwitter}
                        fill="currentcolor"
                        stroke="none"
                        boxSize={iconSize}
                    />
                }
                size={iconBoxSize || "lg"}
                colorScheme="twitter"
                variant="solid"
            />
            <IconButton
                as="a"
                href={`https://instagram.com/chckvet`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow on Instagram"
                icon={<Icon as={FiInstagram} boxSize={iconSize} />}
                size={iconBoxSize || "lg"}
                colorScheme="white"
                bgGradient="linear(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)"
                variant="solid"
            />
            <IconButton
                as="a"
                href={`https://www.linkedin.com/company/chckvet/`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow on Linkedin"
                icon={
                    <Icon
                        as={FiLinkedin}
                        fill="currentcolor"
                        strokeWidth={"1px"}
                        boxSize={iconSize}
                    />
                }
                size={iconBoxSize || "lg"}
                colorScheme="linkedin"
                variant="solid"
            />
            <IconButton
                as="a"
                href={`https://www.facebook.com/chckvet/`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Like on Facebook"
                icon={
                    <Icon
                        as={FiFacebook}
                        fill="currentcolor"
                        stroke="none"
                        boxSize={iconSize}
                    />
                }
                size={iconBoxSize || "lg"}
                colorScheme="facebook"
                variant="solid"
            />
        </Stack>
    )
}

export default SocialIcons
